import { useIllustrationsApi } from 'src/api/db/apiProductImages'
import { useProductVariantColorApi } from 'src/api/db/apiProductVariantColor'
import { parseImageUrls } from '../utils'

interface UseColorMutationsProps {
  variantId: number
  onSuccess?: () => void
}

export const useColorMutations = ({ variantId, onSuccess }: UseColorMutationsProps) => {
  const { createIllustration } = useIllustrationsApi({})
  const { createProductVariantColor } = useProductVariantColorApi()

  const createColorWithImages = async (color: string, imageUrls: string) => {
    // Create the color variant first
    const colorResponse = await createProductVariantColor.mutateAsync({
      product_variant_id: variantId,
      color: color.trim(),
    })

    const colorId = colorResponse.data?.id
    if (!colorId) {
      throw new Error('Failed to create color variant')
    }

    // Then create all images
    const urls = parseImageUrls(imageUrls)
    if (urls.length > 0) {
      await Promise.all(
        urls.map((url) =>
          createIllustration.mutateAsync({
            product_variant_color_id: colorId,
            image_url: url.trim(),
          })
        )
      )
    }

    onSuccess?.()
  }

  return {
    createColorWithImages,
    isCreating: createProductVariantColor.isPending || createIllustration.isPending,
  }
}

